module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1196.6ff7770d.png";